import Base from "@/controllers/base";
export default class ETabs extends Base {
  static click() {
    document.addEventListener("click", (event) => {
      const tabItem = event.target.closest(".el-tabs__item");
      if (tabItem) {
        const tabs = tabItem.closest(".el-tabs");
        if (tabs.classList.contains("no-resize-event")) return;
        setTimeout(() => window.dispatchEvent(new Event("resize")), 100);
      }
    });
  }
}

document.addEventListener("turbo:load", () => {
  ETabs.click();
});
